# See if we can create CustomEvents, if not use a polyfill
module.exports =
  try
    new window.CustomEvent('testEvent')
    window.CustomEvent
  catch
    # Adapted from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    CustomEventPolyfill = ( event, options ) ->
      options ?= { bubbles: false, cancelable: false, detail: undefined }
      evt = document.createEvent( 'CustomEvent' )
      evt.initCustomEvent( event, options.bubbles, options.cancelable, options.detail )
      evt

    CustomEventPolyfill.prototype = window.Event.prototype

    CustomEventPolyfill
